<template>
    <thead :class="setCustomClassHead()">
        <tr>
            <th v-if="header.selection && header.selection.active">
                <checkbox v-model="header.selectAll" @input="callEventSelection" />
            </th>

            <th v-for="(value, key) in header.list" :key="key"
                :class="[setCustomClassCell(key)]">

                <span class="d-flex align-items-center justify-content-between">
                    {{ value }}
                    <i  v-if="sortInfo(key, 'exists')" 
                        :class="['fs-lsmall','ml-2','pointer','fas','darkest', sortInfo(key, 'dir') === 'desc' ? 'fas fa-sort-amount-down' : 'fas fa-sort-amount-up']"
                        @click="sortBy($event, key)">
                    </i>
                </span>
            </th>

            <th v-if="actions.list && actions.list.length > 0" style="width: 1%;" class="text-center">
                {{ actions.label }}
            </th>
        </tr>
    </thead>
</template>

<script>
    export default {
        data() {
            return {
                selectAllStatus: false,
            }
        },
        props: {
            selected: Boolean,
            header: Object,
            actions: Object
        },
        methods: {
            sortBy(e, sortKey) {
                if (!this.header.sort) {
                    return;
                }

                var sortKeyFound = false;

                this.header.sort.list.forEach((obj) => {
                    if (obj.key == sortKey) {
                        obj.direction = obj.direction == 'asc' ? 'desc' : 'asc';
                        sortKeyFound = true;
                    }
                });

                if (!sortKeyFound) {
                    this.header.sort.list.push({ key: sortKey, direction: 'desc' });
                }
            },
            sortInfo(key, what) {
                const list = this.header && this.header.sort && this.header.sort.list;
                const entry = Array.isArray(list) ? list.find(it => it && it.key === key) : null;

                // Exists → true | Not found → false
                if (what === 'exists') return !!entry;
                // 'asc' | 'desc'
                if (what === 'dir') return entry ? entry.direction : null;
                
                return null;
            },
            callEventSelection($event) {
                this.$emit('selectAll', $event);
            },
            setCustomClassCell(key) {
                return (this.header.customClassCell) ? this.header.customClassCell[key] : '';
            },
            setCustomClassHead() {
                return (this.header.customClassHead) ? this.header.customClassHead : '';
            },
        }
}
</script>



// WEBPACK FOOTER //
// baseHeader.vue?96fe5f1a